import { Helmet } from "react-helmet-async";

export function MetaTitle({ children }: { children: string }) {
  return (
    <Helmet>
      <title>Rex | {children}</title>
    </Helmet>
  );
}
